// extracted by mini-css-extract-plugin
export default {"container":"hihb-","tooltip":"_2WXmV"};